import axios from 'axios';
import config from '../config/config';
import apiService from './apiServices';
import { clearStoragePreservingSeen } from '../utils/persistentStorage';
import { persistLogedInUser } from './sessionPersistence';

export default function loginService() {
  const demoUsers = [];

  const login = async (email, password, rememberMe = false, companyOverride) => {
    const companyDb = companyOverride || config.company || 'Hr';
    const tokenFallback = 'api-token';

    // Provo API login së pari
    try {
      const response = await apiService().post(
        'auth/login',
        { email, password },
        companyDb
      );

      if (response?.success && response?.data?.user) {
        const apiUser = response.data.user;
        const company = companyDb;
        let roles =
          Array.isArray(apiUser.roles) && apiUser.roles.length
            ? apiUser.roles
                .map((r) => (r?.name || r?.role_name || r || '').toString().toLowerCase().trim())
                .filter(Boolean)
            : [];
        if ((!roles || roles.length === 0) && (apiUser.user_role || apiUser.role)) {
          const fallbackRole = (apiUser.user_role || apiUser.role || '').toString().toLowerCase().trim();
          if (fallbackRole) roles = [fallbackRole];
        }
        
        const user = {
          success: true,
          data: {
            id: apiUser.id,
            username: apiUser.username,
            firstname: apiUser.firstname,
            lastname: apiUser.lastname,
            email: apiUser.email,
            worker_id: apiUser.worker_id || null,
            roles,
          },
          roles,
          token: apiUser.token || response?.data?.token || tokenFallback,
          company,
          subscription: null,
        };

        // Store refresh token separately for auto-refresh
        const refreshToken = response?.data?.refreshToken || '';
        if (refreshToken) {
          try {
            sessionStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('refreshToken', refreshToken);
          } catch {}
        }

        const jsValue = JSON.stringify(user);
        // Desktop (Electron): ruaj sesionin afatgjatë → kyçje vetëm herën e parë.
        persistLogedInUser(jsValue, rememberMe);

        return user;
      }
    } catch (error) {
      console.error('[loginService] API login error:', error);
    }
    
    // Fallback te demo users nëse API dështon
    const match = demoUsers.find(
      (u) => String(u.email).toLowerCase() === String(email).toLowerCase() && u.password === password
    );
    const company = companyOverride || match?.company || config.company || 'Hr';

    if (!match) {
      console.log('[loginService] No match found in demo users');
      return { success: false, error: 'Invalid credentials' };
    }

    const roles = match.roles || [];
    const user = {
      success: true,
      data: {
        id: match.id,
        username: match.email.split('@')[0],
        firstname: match.firstname || match.email,
        lastname: match.lastname || '',
        email: match.email,
        roles,
      },
      roles,
      token: 'dev-token',
      company,
      subscription: null,
    };

    const jsValue = JSON.stringify(user);
    persistLogedInUser(jsValue, rememberMe);
    return user;
  };

  const lookupCompanyByEmail = (email) => {
    if (!email) return null;
    const found = demoUsers.find(
      (u) => String(u.email).toLowerCase() === String(email).toLowerCase()
    );
    return found?.company || null;
  };

  // const validateUser = (userName, token, rnd) => {

  //     var baseUrl = config.baseUrl + 't3logins/mapi';
  //     return axios.get(baseUrl + `/login/validatenew/${userName}/token/${token}/${rnd}`).then(response => {

  //         if (response.data.success) {
  //             var user = response.data;
  //             user.token = token;
  //             user.rnd = rnd;

  //             var jsValue = JSON.stringify(user);
  //             //if (rememberMe) {
  //             //save login infos on cookie if user clicked rememberMe for 4 days     
  //             let rememberMe = helper().getItem('rememberMe');        
  //             var exdays = (rememberMe) ? 4 : 0;

  //             helper().setItem('logedInUser', jsValue, exdays);               
  //             window.location = '/shops/';
  //             //window.location = '/shops/';
  //         }
  //         return response.data;
  //     });
  // }

  const useAuthCode = (authCode) => {

    var baseUrl = config.baseUrl + 't3logins/mapi';
    return axios.get(baseUrl + `/login/useauthcode/${authCode}`).then(response => {
      //response : {"success":true,"data":[{"id":5,"username":"arsim","firstname":"Arsim","lastname":"Syla","token":"1231231","rnd":111}]}
      return response.data;
    });
  }

  const logout = () => {
    // Pastro refresh token
    try { localStorage.removeItem('refreshToken'); } catch {}
    // Pastro sessionStorage tërësisht
    try { sessionStorage.clear(); } catch {}
    // Pastro localStorage por ruaj çelësat e "Përditësimet e Sistemit"
    clearStoragePreservingSeen();
    // Pastro të gjitha cookies (me path=/ dhe pa path)
    try {
      document.cookie.split(';').forEach(c => {
        const key = c.trim().split('=')[0];
        document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      });
    } catch {}
    window.location.replace('/?logout=1');
  }

  return {
    login,
    logout: logout,
    //validateUser: validateUser,
    useAuthCode: useAuthCode,
    lookupCompanyByEmail,
  }
}
